import { mapState, mapActions } from "pinia";
import LoginState from "%/dynamic-component-editor/options/login-state";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import {
  TextElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-element-mixin";

export const PrimaryNavigationMixin = {
  mixins: [TextElementMixin],
  data() {
    return {
      LoginState,
    };
  },
  computed: {
    ...mapState(useConfigurationStore, [
      "primaryNavigation",
    ]),
    navConfig() {
      return (this.primaryNavigation || []).map(item => {
        return {
          name: item.label,
          label: item.label,
          type: item.type,
          icon: item.icon,
          actionValue: this.getUrlLinkFromType(item),
        };
      });
    },
  },
  methods: {
    ...mapActions(useGeneralStore, [
      "getRelativeHref",
    ]),
    getHashtagLink(hashtag) {
      return this.getRelativeHref(`/stories/${hashtag}`);
    },
    getStaticUrlLink(url) {
      return this.getRelativeHref(url);
    },
    getPostLink(post) {
      return this.getRelativeHref(`/story/${post}`);
    },
    getFeedLink(feed) {
      return this.getRelativeHref(`/feed/${feed}`);
    },
    getPageLink(page) {
      if (page === "/") {
        return this.getRelativeHref(`${page}`);
      }
      return this.getRelativeHref(`/${page}`);
    },
    getUrlLinkFromType(navItem) {
      switch (navItem.type) {
        case "url":
          return this.getStaticUrlLink(navItem.val);
        case "hashtag":
          return this.getHashtagLink(navItem.val);
        case "post":
          return this.getPostLink(navItem.val);
        case "feed":
          return this.getFeedLink(navItem.val);
        case "page":
          return this.getPageLink(navItem.val);
        default:
          return this.getRelativeHref(navItem.val);
      }
    },
  },
};
